
import Modal from "../../../../Components/ExtraComponents/Modal";
import { fDateTimeSuffix } from "../../../../Utils/Date_formet";

import Table from "../../../../Components/ExtraComponents/Tables/FullDataTable";  


const DetailsView = ({ showModal, setshowModal, tradeHistoryData }) => {


  const columns = [
 
  {
    name: "Symbol",
    selector: (row) => row.symbol,
    sortable: true,
    width: "120px",
  },
  {
    name: "Exchange",
    selector: (row) => row.category,
    sortable: true,
    width: "120px",
  },
  {
    name: "Entry Type",
    selector: (row) => row.ordertype,
    cell: (row) =>
     row.side === "LE" || row.side === "SE"  || row.side === "BUY"  ? (
        <span>{row.ordertype}</span>
      ) : (
        <span>-</span>
      ),
    sortable: true,
    width: "120px",
  },
  {
    name: "Exit Type",
    selector: (row) => row.ordertype,
    cell: (row) =>
     row.side === "LX" || row.side === "SX"  || row.side === "SELL"  ? (
        <span>{row.ordertype}</span>
      ) : (
        <span>-</span>
      ),
    sortable: true,
    width: "120px",
  },
 
  {
    name: "Entry Price",
    selector: (row) =>
      row.side === "LE" || row.side === "SE"  || row.side === "BUY"  ? (
        parseFloat(row.price)
      ) : (
        "-"
      ),
    sortable: true,
    width: "130px",
  },
  {
    name: "Exit Price",
    selector: (row) =>
      row.side === "LX" || row.side === "SX" || row.side === "SELL"
        ? parseFloat(row.price)
        : "-",
    sortable: true,
    width: "130px",
  },
  {
    name: "Strategy",
    selector: (row) => row.strategy,
    sortable: true,
    // width: "130px",
  },
     {
      name: "User Type",
      selector: (row) => row.usertype,
      cell: (row) => row?.usertype || "-",
      sortable: true,
      width: "130px",
    },
    {
      name: "Platform",
      selector: (row) => row.platform,
      cell: (row) => row?.platform || "-",
      sortable: true,
      width: "130px",
    },
    {
      name: "Market Type",
      selector: (row) => row.market_type,
      cell: (row) => row?.market_type || "-",
      sortable: true,
      width: "130px",
    },
   
  {
    name: "Signals Time",
    selector: (row) => row.createdAt,
    cell: (row) => (
      <>{row.createdAt ? fDateTimeSuffix(row.createdAt) : "-"}</>
    ),
    sortable: true,
    width: "180px",
  }
  
];



  return (
    <div>
      <Modal
        isOpen={showModal}
        size="xl"
        title="Trade Details"
        hideBtn={true}
        handleClose={() => setshowModal(false)}
      >
        {tradeHistoryData?.ordersData ? (

          // <BasicDataTable
          //   TableColumns={columns1}
          //   tableData={tradeHistoryData.ordersData}
          // />
          <Table
            columns={columns}
            data={tradeHistoryData?.ordersData}
          />

        ) : (

          <div className="text-center">Loading...</div>
        )}
      </Modal>
    </div>
  );
};

export default DetailsView;
